module.exports = __webpack_public_path__ + "static/fav-c59bcde5c89cc7d92c7bec164bebd9de.png";